export enum AccessLevelEnum {
  PHYSICAL = 'physical',
  SOFTWARE_PROVIDER = 'software provider',
  INTERNAL_NETWORK = 'internal network'
}
